export const DCDivestTemplateHeaders = [
    { label: "Line Id", key: "lineId" },
    { label: "Commodity Id", key: "commodityId" },
    { label: "Description", key: "description" },
    { label: "Total Price", key: "totalPrice" },
    { label: "Device Count", key: "quantity" }
];

// Template data format used by SheetJS for Excel (in use)
export const DCDivestTemplateExcelData = [
    {   "Line Id": "1",
        "Commodity Id": "IT Hardware",
        "Description": "Total Price and Device Count of IT Asset Disposal Lot"
    },
    {   "Line Id": "2",
        "Commodity Id": "Maintenance",
        "Description": "Hardware Break/Fix Maintenenance"
    },
    {   "Line Id": "3",
        "Commodity Id": "Other IT Services",
        "Description": ""
    }
];